// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"306":"112fa16a","531":"7bd76802"}[chunkId] + ".chunk.css";
};